import React, { useState, useEffect, useContext } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useNavigate } from "react-router-dom";
import burger from "../../assets/images/coffee.png";
import sandwich from "../../assets/images/coffee.png";
import bowl from "../../assets/images/coffee.png";
import wrap from "../../assets/images/coffee.png";
import shadowLeft from "../../assets/images/cockingShadowLeft.png";
import shadowRight from "../../assets/images/cookingShadowRight.png";
import { getTaggedProducts } from "../../helper/backend-methods";
import ProductCustomizationModal from "../../components/ProductCustomizationModal";
import { addCart } from "../../helper/backend-methods";
import { customToast } from "../../components/customToast";
import { GlobalContext } from "../../context";

const CustomLeftArrow = ({ onClick }) => {
  return (
    <button className="custom-arrow left" onClick={onClick} aria-label="Previous">
      <i className="ri-arrow-left-line"></i>
    </button>
  );
};

const CustomRightArrow = ({ onClick }) => {
  return (
    <button className="custom-arrow right" onClick={onClick} aria-label="Next">
      <i className="ri-arrow-right-line"></i>
    </button>
  );
};

const todaySpecials = [
  { title: "Small Smoked BBQ Pulled Pork", price: "$9.00", img: burger },
  { title: "Grilled Bacon Sandwich", price: "$9.00", img: sandwich },
  { title: "Healthy Power Bowl", price: "$9.00", img: bowl },
  { title: "Fresh Veggie Wrap", price: "$9.00", img: wrap },
];

const signatureDishes = [
  { title: "Classic Beef Burger", price: "$11.00", img: burger },
  { title: "Double Cheese Sandwich", price: "$10.00", img: sandwich },
  { title: "Signature Salad Bowl", price: "$12.00", img: bowl },
  { title: "House Special Wrap", price: "$10.00", img: wrap },
];

const responsive = {
  desktop: { breakpoint: { max: 3000, min: 1080 }, items: 4 },
  tablet: { breakpoint: { max: 1080, min: 800 }, items: 3 },
  mobile: { breakpoint: { max: 800, min: 440 }, items: 2 },
  mobileMin: { breakpoint: { max: 440, min: 0 }, items: 1 },
};

const WhatsCooking = () => {
  const history = useNavigate();
  const [signatureProducts, setSignatureProducts] = useState([]);
  const [todayProducts, setTodayProducts] = useState([]);
  const [activeTab, setActiveTab] = useState("today");
  const data = activeTab === "today" ? todayProducts : signatureProducts;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const { updateCartCount, updateCartDrawer } = useContext(GlobalContext);

  const handleProductClick = (product) => {
    const hasCustomizations =
      product.productAttributes &&
      product.productAttributes.length > 0;

    const productWithDefaults = {
      ...product,
      SelectedAddons: [],
      totalPrice: product.Price || 0
    };

    if (hasCustomizations) {
      setSelectedProduct(productWithDefaults);
      setIsModalOpen(true);
    } else {
      addCart({
        Products: [
          {
            ProductId: product.ProductId,
            Quantity: 1,
            AttributesXml: null,
          },
        ],
      }).then(({ data }) => {
        if (data.Status) {
          customToast.success(
            "Added to Cart",
            "Your item has been successfully added."
          );
          updateCartCount({
            CartItemCount: data.Data.CartItemCount,
            TotalAmount: data.Data.TotalAmount
          });
          updateCartDrawer();
        }
      }).catch((error) => {
        console.error("Error adding to cart:", error);
        customToast.error("Error", "Failed to add item to cart.");
      });
    }
  };


  const getSignatureProducts = () => {
    return getTaggedProducts({tagProductsLimit:15})
      .then(({ data }) => {
        if (data.Status && data.Data) {
          const signatureData = data.Data.find(item => item.Name === "signature dishes");
          if (signatureData && signatureData.Products) {
            setSignatureProducts(signatureData.Products);
          }
        }
      })
      .catch((err) => {
        setSignatureProducts([]);
        console.error("Error fetching signature dishes:", err);
      });
  };

  const getTodayProducts = () => {
    return getTaggedProducts({tagProductsLimit:15, isTodaySpecials:true})
      .then(({ data }) => {
        if (data.Status && data.Data) {
          const todayData = data.Data.find(item => item.Name === "TodaySpecials");
          if (todayData && todayData.Products) {
            setTodayProducts(todayData.Products);
          }
        }
      })
      .catch((err) => {
        setTodayProducts([]);
        console.error("Error fetching today's specials:", err);
      });
  };

  useEffect(() => {
    setLoading(true);
    Promise.allSettled([getSignatureProducts(), getTodayProducts()]).finally(() => setLoading(false));
  }, []);

  return (
    <section id="whatsCooking">
      <div className="wrapper">
        {/* HEADER */}
        <div className="wc-header">
          <h2>WHAT’S COOKING AT MAIN’S</h2>
          <button onClick={() => history("/menu")} className="menu-btn">VIEW OUR MENU</button>
        </div>

        {/* TABS */}
        <div className="wc-tabs">
          <button className={activeTab === "today" ? "active" : ""} onClick={() => setActiveTab("today")}>
            TODAY’S SPECIALS
          </button>

          <button className={activeTab === "signature" ? "active" : ""} onClick={() => setActiveTab("signature")}>
            SIGNATURE DISHES
          </button>
        </div>

        {/* SLIDER */}
        <div className="cocking-container-list">
          <img src={shadowLeft} className="shadow-add shadow-left" />
          <img src={shadowRight} className="shadow-add shadow-right" />
          {!loading && data.length === 0 ? (
            <p className="section-empty-message">No items available right now.</p>
          ) : (
            <Carousel responsive={responsive} infinite arrows customLeftArrow={<CustomLeftArrow />} customRightArrow={<CustomRightArrow />}>
              {data.map((item, index) => (
                <div className="wc-card" key={index}>
                  <img src={item.ProductPictures?.[0]?.Url? item.ProductPictures[0]?.Url : sandwich} alt={item.ProductName} />
                  <h4>{item.ProductName}</h4>
                  <span>{"$" + item.Price}</span>
                  <button className="add-btn" onClick={() => handleProductClick(item)}>+</button>
                </div>
              ))}
            </Carousel>
          )}
        </div>
      </div>
      <ProductCustomizationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        product={selectedProduct}
        toastLink="/openCart"
      />
    </section>
  );
};

export default WhatsCooking;
